
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 9717","d":"M27 0A27 27 0 110 27 27 27 0 0127 0z","fill":"#bece23"}}),_c('path',{attrs:{"data-name":"Path 9718","d":"M22.431 35.503a.54.54 0 01-.383-.159l-5.4-5.4a.54.54 0 01.763-.764l5.022 5.022 14.748-14.749a.54.54 0 01.763.764L22.813 35.348a.532.532 0 01-.382.159z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Path 9718 - Outline","d":"M22.431 36.003a1.035 1.035 0 01-.734-.3l-5.4-5.4a1.04 1.04 0 011.47-1.471l4.669 4.669 14.395-14.4a1.04 1.04 0 111.468 1.472L23.17 35.702a1.024 1.024 0 01-.733.305zm-5.4-6.484a.04.04 0 00-.029.012.04.04 0 000 .055l5.4 5.4a.039.039 0 00.028.012.031.031 0 00.024-.009L37.585 19.86a.036.036 0 00.012-.028.038.038 0 00-.012-.028.037.037 0 00-.028-.012.039.039 0 00-.028.011l-15.1 15.1-5.376-5.376a.038.038 0 00-.026-.008z","fill":"#fff"}})])
          )
        }
      }
    